exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, "/*\n\n.fixed-sets {\n    margin-top: 20px;\n}\n\n@media only screen and (max-width: 600px) {\n    .fixed-sets {\n        width: calc(100vw - 10px);\n        padding: 0 5px;\n    }\n}\n*/\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/Coupons/Coupons.scss
// module id = 1734
// module chunks = 0